<!--
 * @FilePath: /www.feimaoyun.com_html_source/src/views/DownPage/compoents/memberPopUp.vue
 * @Description: 转存下载会员二次确认弹窗
-->
<template>
  <el-dialog
    title="提示"
    :visible.sync="isShow"
    width="480px"
    :before-close="handleClose"
    :append-to-body="true"
    custom-class="memberPopUp"
    :close-on-click-modal="false"
  >
    <div class="dialog-body" style="min-height: 136px">
      <div class="d-header">
        <div class="left">
          <img :src="$utils.getPng('web4/icon-circle-fill')" />
          <span>{{ downFileFlag ? "确定下载文件？" : "确定转存文件？" }}</span>
        </div>
        <fm-button
          type="info"
          size="mini"
          text
          icon="icon-model-close"
          @click="handleClose"
        ></fm-button>
      </div>
      <div class="d-content" style="margin-top: 30px">
        <!-- <img
          @click="tovip()"
          class="popupImg pointer"
          :src="rebate_model_popup_img"
        /> -->
        <div class="popupImg-box pointer" @click="tovip()">
          <img class="popupImg" :src="rebate_model_popup_info.icon" />
          <div class="infoList">
            <div
              class="label-box"
              v-for="(item, index) in rebate_model_popup_info.list"
              :key="index"
              :style="{margin: index == 1 ? '0 16px' : '0'}"
            >
              <img class="icon" :src="item.icon" alt="" />
              <div class="label">{{ item.label }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-footer" style="margin-top: 24px">
        <fm-button
          style="min-width: 120px"
          @click="toTurnFile()"
          round
          size="medium"
          >{{
            !downFileFlag
              ? "转存至云盘"
              : $store.state.userInfo.is_vip == 1
              ? "转存并极速下载"
              : "转存并普通下载"
          }}</fm-button
        >
        <fm-button
          style="width: 120px"
          type="info"
          plain
          round
          size="medium"
          @click="todown"
          v-if="downFileFlag"
          >{{
            $store.state.userInfo.is_vip == 1 ? "极速下载" : "普通下载"
          }}</fm-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    rebate_model_popup_info: {
      type: Object,
      default: {},
    },
    downFileFlag: {
      type: Number,
      default: 0,
    },
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },

    todown() {
      this.$emit("todown");
    },
    toTurnFile() {
      this.$emit("toTurnFile", this.downFileFlag);
    },
    tovip() {
      let rebate_model = sessionStorage.getItem("rebate_models");
      let expand = rebate_model == 6;
      if (this.downFileFlag == 0) {
        //转存 不需要判断会员
        this.$utils.routeModeReported("C36", this.$store.state.voucher);
        if (expand) {
          sessionStorage.setItem("expand", "C36");
        }
      } else {
        //下载判断会员身份
        if (this.$store.state.userInfo.is_vip == 1) {
          //会员
          this.$utils.routeModeReported("C34", this.$store.state.voucher);
          if (expand) {
            sessionStorage.setItem("expand", "C34");
          }
        } else {
          this.$utils.routeModeReported("C35", this.$store.state.voucher);
          if (expand) {
            sessionStorage.setItem("expand", "C35");
          }
        }
      }
      window.open("/vip", "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.memberPopUp {
  .d-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .d-footer {
    display: flex;
    justify-content: center;
    margin-top: 24px;
  }
  .popupImg-box {
    max-width: 432px;
    height: 142px;
    text-align: center;

    .popupImg {
      width: 88px;
      height: 88px;
    }
    .infoList {
      margin-top: 24px;
      display: flex;
      justify-content: center;
      width: 430px;

      .label-box {
        display: flex;
        .icon {
          width: 22px;
          height: 22px;
          margin-right: 4px;
        }
        .label {
          font-weight: 500;
          font-size: 14px;
          color: #f67942;
          line-height: 22px;
          text-align: left;
        }
      }
    }
  }
}
</style>
